import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AdminLogin from "../pages/admin/login/page";
import AdminDashboard from "../pages/admin/dashboard/page";
import AdminCategories from "../pages/admin/categories/page";
import AdminProducts from "../pages/admin/products/page";
import AdminSettings from "../pages/admin/settings/page";
import AdminGuard from "../pages/admin/components/AdminGuard";
import ProductPage from "../pages/product/page";
import CategoryPage from "../pages/category/page";
import CatalogPage from "../pages/catalog/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/catalogo",
    element: <CatalogPage />,
  },
  {
    path: "/produto/:slug",
    element: <ProductPage />,
  },
  {
    path: "/categoria/:slug",
    element: <CategoryPage />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: (
      <AdminGuard>
        <AdminDashboard />
      </AdminGuard>
    ),
  },
  {
    path: "/admin/categories",
    element: (
      <AdminGuard>
        <AdminCategories />
      </AdminGuard>
    ),
  },
  {
    path: "/admin/products",
    element: (
      <AdminGuard>
        <AdminProducts />
      </AdminGuard>
    ),
  },
  {
    path: "/admin/settings",
    element: (
      <AdminGuard>
        <AdminSettings />
      </AdminGuard>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;